import React, { memo } from 'react';
import { styled as styled2 } from '@compiled/react';
import Tooltip from '@atlaskit/tooltip';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { Props } from './types.tsx';

export const CardType = memo(({ text, uri }: Props) => {
	return (
		<Icon>
			<Tooltip content={text}>
				<Image alt={text} src={uri} />
			</Tooltip>
		</Icon>
	);
});

export default CardType;

const iconSize = gridSize * 2;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled2.div({
	display: 'flex',
	justifyContent: 'center',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard -- Ignored via go/DSP-18766
export const Image = styled2.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${iconSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${iconSize}px`,
	verticalAlign: 'text-bottom',
});
